import React__default from 'react';
import { AlertDialog } from 'radix-ui';
import { Icon as IconMemo } from '../Icon/index.js';
import { Button } from '../Button/index.js';
import { IconSize } from '../../lib/constants.js';
import classnames from 'classnames';
import styles from './index.module.scss.js';

const ShortModal = ({ open, title, buttonConfiguration, hasCloseButton = true, onClose, children, ariaDescribedBy, }) => {
    const hasOnlyContent = !buttonConfiguration && !title && !hasCloseButton;
    const renderHeader = hasCloseButton || !!title;
    const handleIsOpen = (isOpen) => {
        if (!isOpen) {
            onClose?.();
        }
    };
    return (React__default.createElement(AlertDialog.Root, { open: open, onOpenChange: handleIsOpen },
        React__default.createElement(AlertDialog.Portal, null,
            React__default.createElement(AlertDialog.Overlay, { className: styles.dialogOverlay }),
            React__default.createElement(AlertDialog.Content, { className: styles.dialogContent, "aria-describedby": ariaDescribedBy },
                renderHeader && (React__default.createElement("header", { className: styles.dialogHeader },
                    hasCloseButton && (React__default.createElement(AlertDialog.Cancel, { className: styles.closeButton, "aria-label": "Chiudi il modale" },
                        React__default.createElement(IconMemo, { name: "Close", iconSize: IconSize.MD }))),
                    title && (React__default.createElement(AlertDialog.Title, { className: classnames('headline-6', styles.dialogTitle, {
                            [styles.noCloseButton]: !hasCloseButton,
                        }) }, title)))),
                typeof children === 'string' ? (React__default.createElement(AlertDialog.Description, { className: classnames(styles.dialogDescription, {
                        [styles.onlyContent]: hasOnlyContent,
                    }) }, children)) : (React__default.createElement("div", { className: classnames(styles.dialogDescription, {
                        [styles.onlyContent]: hasOnlyContent,
                    }) }, children)),
                buttonConfiguration && (React__default.createElement("footer", { className: styles.dialogFooter },
                    React__default.createElement(Button, { type: "button", design: buttonConfiguration.main.design, onClick: buttonConfiguration.main.action, classes: [styles.mainButton] }, buttonConfiguration.main.text),
                    buttonConfiguration.secondary && (React__default.createElement(Button, { type: "button", design: buttonConfiguration.secondary.design, onClick: buttonConfiguration.secondary.action, classes: [styles.secondaryButton] }, buttonConfiguration.secondary.text))))))));
};

export { ShortModal };
//# sourceMappingURL=index.js.map
